<template>
  <div
    v-loading="loading"
    element-loading-text="数据加载中..."
    element-loading-spinner="el-icon-loading"
    :style="{ height: tableHeight }"
    ref="tablebox"
    :class="['l-x-table', isPage ? 'l-x-table--haspagination' : '']"
  >
    <div class="l-rblock">
      <vxe-table
        :data="tableShowData"
        style="width: 100%"
        :height="tableHeight"
        :max-height="maxHeight"
        :size="size"
        :cell-style="cellStyle || { padding: '2px 0' }"
        :header-cell-style="headerCellStyle || { padding: '2px 0' }"
        :stripe="stripe && !isTree"
        :row-config="{
          isHover: isRowHover,
          isCurrent: highlightCurrentRow || singleSelect,
          keyField: rowKey,
        }"
        :column-config="{
          resizable: isColumnResizable,
          isCurrent: isColumnCurrent,
          isHover: isColumnHover,
          minWidth: '80px'
        }"
        :checkbox-config="{
          checkField: multiSelectKey,
          reserve: reserveSelection && isMultiSelect,
          checkStrictly: checkStrictly && isTree,
          checkMethod: selectable
        }"
        :seq-config="{
          seqMethod: indexMethod
        }"
        :tooltip-config="{
          theme: tooltipEffect
        }"
        :sort-config="{
          remote: isPage
        }"
        :border="border"
        :fit="fit"
        :show-header="showHeader"
        :show-footer="showSummary"
        :show-overflow="showOverflow"
        :empty-text="emptyText"
        :footer-method="getSummaries"
        :footer-span-method="footerRowspanMethod"
        :span-method="spanMethod"
        :menu-config="menuConfig"
        :tree-config="treeConfig"
        :scroll-y="myScrollY"
        :scroll-x="{
            enabled: !isExpand,
            gt: scrollXGt
        }"
        :mergeCells="mergeCells"
        :row-class-name="rowClassName"
        :cell-class-name="cellClassName"
        :header-row-class-name="headerRowClassName || 'l-x-table-header-row'"
        :header-cell-class-name="headerCellClassName"
        :default-sort="defaultSort"
        :row-style="rowStyle"
        @scroll="scroll"
        @checkbox-all="handleSelectAll"
        @checkbox-change="selectionChange"
        @cell-mouseenter="cellMouseEnter"
        @cell-mouseleave="cellMouseLeave"
        @cell-click="handleCellClick"
        @cell-dblclick="handleCellDblclick"
        @cell-menu="headerContextmenu"
        @row-click="rowClick"
        @row-contextmenu="rowContextmenu"
        @row-dblclick="rowDblclick"
        @header-cell-click="headerClick"
        @header-cell-menu="headerContextmenu"
        :header-row-style="headerRowStyle"
        @header-contextmenu="headerContextmenu"
        @sort-change="sortChangeEvent"
        @filter-change="filterChange"
        @current-change="currentChangeHandler"
        @resizable-change="headerDagend"
        @toggle-row-expand="expandChange"
        ref="learunTable"
        v-if="isShowTable"
      >
        <!-- 开启显示树形数据的拖动排序 -->
        <vxe-column align="center" width="45" v-if="isSortable && isTree">
          <template slot="header">
            <i class="el-icon-sort" />
          </template>
          <template slot-scope="scope">
            <span class="learun-table__drag-handler" style="cursor: pointer;" @click="reorder(scope.row)">
              <i class="el-icon-d-caret" />
            </span>
          </template>
        </vxe-column>
        <!-- 拖动排序  -->
        <vxe-column align="center" width="45" v-if="isSortable && !isTree">
          <template slot="header">
            <i class="el-icon-sort" />
          </template>
          <template>
            <span class="learun-table__drag-handler" style="cursor: pointer;">
              <i class="el-icon-rank" />
            </span>
          </template>
        </vxe-column>

        <vxe-column
          v-if="isExpand"
          :fixed="isFixed ? 'left' : ''"
          type="expand"
          width="32"
        >
          <template #content="scope">
            <slot v-bind="scope" name="table_expand"></slot>
          </template>
        </vxe-column>
        <!-- <template v-slot:append>
          <slot name="append"></slot>
        </template> -->
        <vxe-column
          v-if="isShowNum && !isTree"
          :title="ShowNumLabel"
          :fixed="isFixed ? 'left' : ''"
          type="seq"
          :width="seqWidth"
          align="center"
          :resizable="false"
        >
        </vxe-column>
        <vxe-column
          v-if="isMultiSelect && !singleSelect"
          :fixed="isFixed ? 'left' : ''"
          type="checkbox"
          align="center"
          width="60"
          :resizable="false"
        >
          <!-- <template v-slot:checkbox="scope">
            <el-checkbox v-model="scope.row.checked" :disabled="scope.row.disabled" size="mini"></el-checkbox>
          </template> -->
        </vxe-column>
        <vxe-column
          v-if="singleSelect"
          :fixed="isFixed ? 'left' : ''"
          title=""
          width="35">
          <template v-slot="scope">
            <el-radio v-model="curtRowKey" :label="scope.row[rowKey]">&nbsp;</el-radio>
          </template>
        </vxe-column>

        <template v-for="(item, index) in tableColumns">
          <vxe-column
            v-if="!item.children"
            :key="`${item.prop}${index}`"
            :field="item.prop"
            v-bind="item"
            :title="$t(item.label)"
            :fixed="isSortable && !isTree ? '' : (item.fixed === true ? 'left' : '')"
            :sortable="sortable || item.sortable"
            :show-overflow="(item.isNotAutoWrap == true ? true : false)  || item.fixed"

            :min-width="item.minWidth"
            :tree-node="isTree && index == 0"
          >
            <template v-slot:header="{ column }">
              <span v-if="isRequired(column.property)" style="color: red"
                >*</span
              ><span>{{ column.title }}</span>
            </template>
            <template v-slot="slotProps">
              <slot v-bind="slotProps" :name="item.prop">{{
                columnText(slotProps.$index, slotProps.row, item, slotProps)
              }}</slot>
            </template>
          </vxe-column>
          <x-dynamic-column
            v-else
            :showOverflowTooltip="(item.isNotAutoWrap == true ? true : false || item.fixed)"
            :columnOption="item"
            :columnText="columnText"
            :isRequired="isRequired"
            :title="$t(item.label)"
            :key="index"
            :fixed="isSortable && !isTree ? '' : (item.fixed === true ? 'left' : item.fixed)"
            :sortable="sortable"
            :allProps="item.props"
            :colIndex="index"
          >
            <template
              v-for="myProp in item.props || []"
              v-slot:[myProp]="scope"
            >
              <slot v-bind="scope" :name="myProp"></slot>
            </template>
          </x-dynamic-column>
        </template>
        <slot></slot>
      </vxe-table>
      
    </div>

    <div v-if="isPage" class="l-table--pagination">
      <el-pagination
        small
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="pageSizes || [20, 50, 100, 200]"
        :page-size.sync="currentPageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageTotal"
      >
      </el-pagination>
    </div>
    <l-drawer
      :title="$t('表格列设置')"
      :visible.sync="columnsVisible"
      :showOk="false"
      :showClose="false"
      :wrapperClosable="true"
      :modal="false"
      size="320px"
      @opened="columnsSettingOpened"
    >
      <el-tree
        ref="columnsTree"
        node-key="_id"
        show-checkbox
        :data="treeColumns"
        @check="handleColumnsCheck"
        draggable
        :allow-drop="allowDrop"
        @node-drop="handleDrop"
      >
      </el-tree>
    </l-drawer>
  </div>
</template>
<script>
import tableEvent from "@util/newTableEvent";
import tableUtil from "@util/tableUtil";
import xDynamicColumn from "./x-dynamic-column";
import {cloneDeep} from 'lodash';
// 事件： sortable-change(表格行排序变更触发)
export default {
  name: "l-new-table",
  mixins: [tableEvent(), tableUtil()],
  components: {
    xDynamicColumn,
  },
  props: {
    disabeledList: {
      default: ''
    },
    columns: {
      type: Array,
      default: function () {
        return [];
      },
    },
    columnsType: {
      type: String,
      default: "tree",
    },
    dataSource: {
      type: Array,
      default: function () {
        return [];
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    height: {
      type: [String, Number],
      default: "100%",
    },
    maxHeight: {
      type: [String, Number],
    },
    minHeight: {
      type: [String, Number],
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
    highlightCurrentRow: {
      type: Boolean,
      default: true,
    },
    rowClassName: [String, Function],
    cellClassName: [String, Function],
    headerRowClassName: [String, Function],
    headerCellClassName: [String, Function],
    rowStyle: [Function, Object],
    cellStyle: [Function, Object],
    headerCellStyle: [Function, Object],
    stripe: {
      type: Boolean,
      default: true,
    },
    border:{
      type: [String, Boolean],
      default: false
    },
    tooltipEffect: String,
    showSummary: {
      type: Boolean,
      default: false,
    },
    showOverflow: [String, Boolean],
    sumText: {
      type: String,
      default: "合计",
    },
    summaryMethod: Function,
    isShowNum: {
      type: Boolean,
      default: true,
    },
    ShowNumLabel: {
      type: String,
      default: "序号",
    },
    ShowNumWidth:{
      type: [String, Number],
      default: "55",
    },
    isMultiSelect: Boolean,
    multiSelectKey: String,
    rowKey: String,
    reserveSelection: {
      type: Boolean,
      default: true,
    },
    isExpand: {
      type: Boolean,
      default: false,
    },
    isTree: {
      type: Boolean,
      default: false,
    },
    idKey: {
      type: String,
    },
    pidKey: {
      type: String,
    },
    indent: {
      type: Number,
      default: 16,
    },
    lazy: Boolean,
    load: Function,
    defaultExpandAll: Boolean,
    checkStrictly: Boolean,
    expandRowKeys: {
      type: Array,
    },
    sortable: {
      type: Boolean,
      default: false,
    },
    defaultSort: Object,
    isSortable: {
      type: Boolean,
      default: false,
    },
    spanMethod: Function,
    isPage: {
      type: Boolean,
      default: false,
    },
    pageSizes: Array,
    pageTotal: {
      type: Number,
      default: 0,
    },
    tablePage: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 50,
    },
    pageLayout: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper",
    },
    isChild: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    lrTableName: {
      type: String,
      default: function () {
        return window.location.href;
      },
    },
    hasChildren: {
      type: String,
      default: "hasChildren",
    },
    scrollYGt: {
      type: Number,
      default: 50,
    },
    scrollXGt: {
      type: Number,
      default: 50,
    },
    // 似乎是用来给原有框架中指定table的border属性的参数，但现已改为直接使用border属性
    borderType: {
      type: String,
    },
    isRowHover: {
      type: Boolean,
      default: true,
    },
    isColumnCurrent: Boolean,
    isColumnHover: {
      type: Boolean,
      default: false,
    },
    isColumnResizable: {
      type: Boolean,
      default: true,
    },
    isNotMinWidth: Boolean,
    mergeCells: Array,
    isBigData: Boolean,
    size: {
      default: 'mini'
    },
    singleSelect: {
      default: false
    },
    currentRowKey: {
      default: ''
    }
  },
  data() {
    return {
      columnsVisible: false,
      columnsChecks: null,
      myPageSize: 0,
      sidx: "",
      isShowTable: true,
      isReloading: false,
      dataId: this.$uuid(),
      bigDataLength: -1,
      curtRowKey: '',
      emptyText:'暂无数据'
    };
  },
  created() {
    window.tableData = window.tableData || {};
  },
  beforeDestroy: function () {
    this.dragSortable && this.dragSortable.destroy() && (this.dragSortable = null);
    delete window.tableData[this.dataId];
  },
  mounted() {
    this.curtRowKey = this.currentRowKey
    this.setSort();
  },
  computed: {
    tableHeight: function () {
      return "notset" == this.height || this.isChild ? void 0 : "100%";
    },
    tableWraperHeight: function () {
      return "notset" == this.height || this.isChild ? void 0 : this.height;
    },
    isFixed: function () {
      return (
        void 0 !=
          this.arrayColumns.find(function (e) {
            return e.fixed || "left" === e.fixed || "right" === e.fixed;
          }) && !this.isSortable
      );
    },
    dataSourceLength: function () {
      return -1 != this.bigDataLength
        ? this.bigDataLength
        : this.dataSource.length;
    },
    seqWidth: function () {
      var e = this.indexMethod({rowIndex: this.dataSourceLength}) + "",
        t = 10 * e.length + 20;
      return t < this.ShowNumWidth && (t = this.ShowNumWidth), t;
    },
    // border: function () {
    //   return -1 !=
    //     this.tableColumns.findIndex(function (e) {
    //       return e.children && e.children.length > 0;
    //     })
    //     ? "full"
    //     : this.borderType || false;
    // },
    footerColNum: function () {
      var e = 0;
      return this.isShowNum && e++, this.isMultiSelect && e++, e;
    },
    myScrollY: function () {
      return this.isExpand
        ? {
            enabled: false,
          }
        : this.lazy
        ? {
            enabled: true,
          }
        : {
            gt: this.scrollYGt,
            enabled: true,
          };
    },
    treeConfig: function () {
      return this.isTree
        ? {
            transform: this.lazy,
            rowField: this.idKey || this.rowKey,
            parentField: this.pidKey,
            expandAll: this.defaultExpandAll,
            indent: this.indent,
            lazy: this.lazy,
            loadMethod: this.load,
            hasChildField: this.hasChildren,
            hasChild: this.hasChildren,
            expandRowKeys: this.expandRowKeys,
            reserve: true,
          }
        : null;
    },
    menuConfig: function () {
      return {
        enabled: true,
      };
    },
    arrayColumns: function () {
      let e = this.columnsType == "tree" ? this.$toArray(this.columns) : this.columns;
      return e;
    },
    treeColumns: function () {
      return this.$toTree(this.$deepClone(this.arrayColumns));
    },
    chooseItem: function () {
      var e,
        t = this;
      return 0 == this.arrayColumns.length
        ? [
            {
              label: "",
              prop: "learun_null",
              minWidth: "1",
            },
          ]
        : ((e =
            null != this.columnsChecks
              ? this.arrayColumns.filter(function (e) {
                  return -1 != t.columnsChecks.indexOf(e._id);
                })
              : this.arrayColumns.filter(function (e) {
                  return -1 != t.defaultCheckedKeys.indexOf(e._id);
                })),
          0 == e.length
            ? [
                {
                  label: "",
                  prop: "learun_null",
                  minWidth: "1",
                },
              ]
            : (this.isNotMinWidth ||
                -1 !=
                  e.findIndex(function (e) {
                    return e.minWidth;
                  }) ||
                ((e[0].minWidth = e[0].width || "1"), delete e[0].width),
              e));
    },
    tableColumns: function () {
      return this.$toTree(this.chooseItem);
    },
    defaultCheckedKeys: function () {
      var e,
        t = window.$getStore({
          name: "table_setting_cols",
        });
      if (
        t &&
        (this.loginInfo
          ? t[this.loginInfo.f_UserId] &&
            t[this.loginInfo.f_UserId][this.lrTableName] &&
            (e = t[this.loginInfo.f_UserId][this.lrTableName])
          : (e = t[this.lrTableName]),
        e)
      )
        return e;
      return this.arrayColumns
        .filter(function (e) {
          return 1 != e.isNotShow;
        })
        .map(function (e) {
          return e._id;
        });
    },
    currentPageSize: {
      get: function () {
        return 0 != this.myPageSize ? this.myPageSize : this.pageSize;
      },
      set: function (e) {
        (this.myPageSize = e), this.$emit("update:pageSize", e);
      },
    },
    currentPage: {
      get: function () {
        return this.$validatenull(this.tablePage) ? 1 : this.tablePage;
      },
      set: function (e) {
        this.$emit("update:tablePage", e);
      },
    },
    tableShowData: function () {
      var e = [];
      if (this.isTree && !this.lazy) {
        if (this.isReloading) return [];
        e = this.$toTree(
          this.dataSource,
          this.idKey || this.rowKey,
          this.pidKey,
          this.rowKey,
          this.rowKey
        );
      } else e = this.dataSource;
      return e;
    },
  },
  watch: {
    currentRowKey(val) {
      this.curtRowKey = val;
    },
    showColumns(val) {
      this.columnsChecks = this.showColumns;
    },
    dataSource() {
      if (this.isChild) {
        let list = this.$el.querySelectorAll(".el-table__row");
        list.forEach((row) => {
          row.classList.add("el-table__row2");
          row.classList.remove("el-table__row");
        });
        list = null
      }
      // this.selectRows();
    },
    columnsChecks(val) {
      if (!this.tid || !this.loginInfo.f_UserId) return;
      let tableConfig = window.$getStore({ name: "tableConfig" }) || {},
        mayConfig = tableConfig[this.loginInfo.f_UserId];
      if (!mayConfig) tableConfig[this.loginInfo.f_UserId] = {};
      tableConfig[this.loginInfo.f_UserId][this.tid] = val;
      window.$setStore({ name: "tableConfig", content: tableConfig });
    },
  },
  methods: {
    updateFooter() {
      this.$refs.learunTable.updateFooter()
    },
    loadEmptyText(){
      this.emptyText = '     '
    },
    setEmptyText(){
      this.emptyText = '暂无数据'
    },
    scroll($event){
      let event = $event
      // setTimeout(()=>{
        // 动态赋值表头偏移量
          let container = this.$refs['learunTable'].$el.querySelector('.vxe-table--header-wrapper')
          container.scrollLeft = event.scrollLeft
          container = null
          // console.log(event.scrollLeft,'event.scrollLeft');
          // console.log(container,'container');
          // console.log(container.scrollLeft,'container.scrollLeft');
      // },20)
      this.$emit('scroll',$event)
    },
    // 用于开启显示树形数据时传递行的数据，进而实现树形数据的拖拽排序
    reorder(row){
      this.$emit('reorder',row)
    },
    selectable ({row}) {
      if (!this.rowKey) return true
      let bol = this.disabeledList.indexOf(row[this.rowKey]) == -1
      return bol
    },
    getDataSource: function () {
      var e = window.tableData[this.dataId];
      if (!e) return this.dataSource;
    },
    setDataSource: function (e) {
      (this.bigDataLength = e.length), (window.tableData[this.dataId] = e);
    },
    handleSelectionChange: function (e) {
      var t = e.checked,
        n = e.row,
        r = e.rowIndex,
        i = e.$rowIndex,
        o = e.column,
        a = e.columnIndex,
        l = e.$columnIndex,
        s = e.$event;
      this.$emit("select", {
        checked: t,
        row: n,
        rowIndex: r,
        $rowIndex: i,
        column: o,
        columnIndex: a,
        $columnIndex: l,
        $event: s,
      });
    },
    handleSelectAll: function (e) {
      this.selectAll(e.records)
      // var t = e.checked,
      //   n = e.$event;
      // this.$emit("selectAll", {
      //   checked: t,
      //   $event: n,
      // });
    },
    handleCellClick: function (e) {
      var t = e.row,
        n = e.rowIndex,
        r = e.$rowIndex,
        i = e.column,
        o = e.columnIndex,
        a = e.$columnIndex,
        l = e.triggerRadio,
        s = e.triggerCheckbox,
        u = e.triggerTreeNode,
        c = e.triggerExpandNode,
        f = e.$event;
      this.$emit("rowClick", {
        row: t,
        column: i,
        $event: f,
      }),
        this.$emit("cellClick", {
          row: t,
          rowIndex: n,
          $rowIndex: r,
          column: i,
          columnIndex: o,
          $columnIndex: a,
          triggerRadio: l,
          triggerCheckbox: s,
          triggerTreeNode: u,
          triggerExpandNode: c,
          $event: f,
        });
    },
    handleCellDblclick: function (e) {
      var t = e.row,
        n = e.rowIndex,
        r = e.$rowIndex,
        i = e.column,
        o = e.columnIndex,
        a = e.$columnIndex,
        l = e.$event;
      this.$emit("rowDblclick", {
        row: t,
        column: i,
        $event: l,
      }),
        this.$emit("cellDblclick", {
          row: t,
          rowIndex: n,
          $rowIndex: r,
          column: i,
          columnIndex: o,
          $columnIndex: a,
          $event: l,
        });
    },
    handleCellMenu: function (e) {
      var t = e.row,
        n = e.column,
        r = e.$event;
      this.$emit("rowContextmenu", {
        row: t,
        column: n,
        $event: r,
      });
    },
    cellMouseEnter: function (e) {
      var t = e.row,
        n = e.rowIndex,
        r = e.$rowIndex,
        i = e.column,
        o = e.columnIndex,
        a = e.$columnIndex,
        l = e.$event;
      this.$emit("cellMouseEnter", {
        row: t,
        rowIndex: n,
        $rowIndex: r,
        column: i,
        columnIndex: o,
        $columnIndex: a,
        $event: l,
      });
    },
    cellMouseLeave: function (e) {
      var t = e.row,
        n = e.rowIndex,
        r = e.$rowIndex,
        i = e.column,
        o = e.columnIndex,
        a = e.$columnIndex,
        l = e.$event;
      this.$emit("cellMouseLeave", {
        row: t,
        rowIndex: n,
        $rowIndex: r,
        column: i,
        columnIndex: o,
        $columnIndex: a,
        $event: l,
      });
    },
    headerClick: function (e) {
      var t = e.$rowIndex,
        n = e.column,
        r = e.columnIndex,
        i = e.$columnIndex,
        o = e.triggerResizable,
        a = e.triggerSort,
        l = e.triggerFilter,
        s = e.$event;
      this.$emit("headerClick", {
        $rowIndex: t,
        column: n,
        columnIndex: r,
        $columnIndex: i,
        triggerResizable: o,
        triggerSort: a,
        triggerFilter: l,
        $event: s,
      });
    },
    headerContextmenu: function (e) {
      var t = e.type,
        n = e.column,
        r = e.columnIndex,
        i = e.$event;
      this.$emit("headerContextmenu", {
        type: t,
        column: n,
        columnIndex: r,
        $event: i,
      });
    },
    filterChange: function (e) {
      var t = e.column,
        n = e.property,
        r = e.values,
        i = e.datas,
        o = e.filterList,
        a = e.$event;
      this.$emit("filterChange", {
        column: t,
        property: n,
        values: r,
        datas: i,
        filterList: o,
        $event: a,
      });
    },
    currentChangeHandler (e) {
      let currentRow = e.newValue,
          oldCurrentRow = e.oldValue
      this.curtRowKey = currentRow[this.rowKey]
      this.$emit('update:currentRowKey', this.curtRowKey)
      this.currentChange(currentRow, oldCurrentRow)
      // var t = e.newValue,
      //   n = e.oldValue,
      //   r = e.row,
      //   i = e.rowIndex,
      //   o = e.$rowIndex,
      //   a = e.column,
      //   l = e.columnIndex,
      //   s = e.$columnIndex,
      //   u = e.$event;
      // this.$emit("currentChange", {
      //   newValue: t,
      //   oldValue: n,
      //   row: r,
      //   rowIndex: i,
      //   $rowIndex: o,
      //   column: a,
      //   columnIndex: l,
      //   $columnIndex: s,
      //   $event: u,
      // });
    },
    headerDagend: function (e) {
      var t = e.$rowIndex,
        n = e.column,
        r = e.columnIndex,
        i = e.$columnIndex,
        o = e.$event;
      this.$emit("headerDagend", {
        $rowIndex: t,
        column: n,
        columnIndex: r,
        $columnIndex: i,
        $event: o,
      });
    },
    expandChange: function (e) {
      var t = e.expanded,
        n = e.row,
        r = e.rowIndex,
        i = e.$rowIndex,
        o = e.column,
        a = e.columnIndex,
        l = e.$columnIndex,
        s = e.$event;
      this.$emit("expandChange", {
        expanded: t,
        row: n,
        rowIndex: r,
        $rowIndex: i,
        column: o,
        columnIndex: a,
        $columnIndex: l,
        $event: s,
      });
    },
    handleSizeChange: function (e) {
      (this.currentPageSize = e),
        this.$emit("loadPageData", {
          rows: e,
          page: this.currentPage,
          sidx: this.pageSidx,
        });
    },
    handleCurrentChange: function (e) {
      (this.currentPage = e),
        this.$emit("loadPageData", {
          rows: this.currentPageSize,
          page: e,
          sidx: this.pageSidx,
        });
    },
    sortChangeEvent: function (e) {
      var t = e.sortList;
      if (this.isPage) {
        var n = t
          .map(function (e) {
            return "".concat(e.property, " ").concat(e.order);
          })
          .join(", ");
        (this.pageSidx = n),
          this.$emit("loadPageData", {
            rows: this.currentPageSize,
            page: this.currentPage,
            sidx: n,
          });
      }
    },
    reset: function () {
      this.clearSelection();
    },
    clearSelection: function () {
      this.$refs.learunTable.clearCheckboxRow(),
        this.reserveSelection &&
          this.isMultiSelect &&
          this.$refs.learunTable.clearCheckboxReserve();
    },
    toggleRowSelection: function (e, t) {
      this.$refs.learunTable.setCheckboxRow(e, t);
    },
    getSelected: function (e) {
      var t = this.$refs.learunTable.getCheckboxRecords();
      return t;
    },
    loadData: function (e) {
      return this.setDataSource(e), this.$refs.learunTable.reloadData(e);
    },
    reLoadData: function () {
      var e = this;
      (this.isReloading = true),
        this.$nextTick(function () {
          e.isReloading = false;
        });
    },
    doLayout: function (bol) {
      var e = this;
      (this.isShowTable = false),
        this.$nextTick(function () {
          e.isShowTable = true;
          if(bol){
            e.setSort()
          }
        });
    },
    clearCurrentColumn: function () {
      return this.$refs.learunTable.clearCurrentColumn();
    },
    indexMethod: function (e) {
      var t = e.rowIndex;
      return this.isPage
        ? (this.currentPage - 1) * this.currentPageSize + t + 1
        : t + 1;
    },
    // setSort: function () {
    //   var e = this,
    //     t = function () {
    //       var t = e.$refs.learunTable.$el.querySelectorAll(
    //         ".vxe-table--body-wrapper > table > tbody"
    //       )[0];
    //       e.dragSortable = window.Sortable.create(t, {
    //         ghostClass: "learun-table__sortable",
    //         handle: ".learun-table__drag-handler",
    //         onEnd: function (t) {
    //           var n = t.oldIndex,
    //             r = t.newIndex,
    //             i = e.getDataSource(),
    //             o = i.splice(n, 1)[0];
    //           i.splice(r, 0, o), e.$emit("sortable-change", n, r, o, i);
    //         },
    //       });
    //     };
    //   this.isSortable &&
    //     !this.isTree &&
    //     this.$nextTick(function () {
    //       t();
    //     });
    // },
    setSort() {
      const callback = () => {
        this.$nextTick(() => {
          let el = this.$refs.learunTable.$el.querySelectorAll(
          ".vxe-table--body-wrapper > table > tbody"
        )[0];

        this.dragSortable = window.Sortable.create(el, {
          ghostClass: "learun-table__sortable",
          handle: ".learun-table__drag-handler",
          onEnd: (evt) => {
            const oldindex = evt.oldIndex;
            const newindex = evt.newIndex;
            // let dataSource = cloneDeep(this.getDataSource())
            // this.dataSource = cloneDeep([])
            // const targetRow = dataSource.splice(oldindex, 1)[0];
            // console.log(targetRow)
            // // console.log(this.dataSource,'dataSource===aftersplice');
            // dataSource.splice(newindex, 0, targetRow);
            // dataSource.forEach((row, index) => {
            //   row.seq = index + 1;
            // })
            // console.log(dataSource);
            // this.dataSource = dataSource

            let dataSource = this.getDataSource()
            // this.dataSource = cloneDeep([])
            const targetRow = dataSource.splice(oldindex, 1)[0];
            console.log(targetRow)
            // console.log(this.dataSource,'dataSource===aftersplice');
            dataSource.splice(newindex, 0, targetRow);
            dataSource.forEach((row, index) => {
              row.seq = index + 1;
            })
            console.log(dataSource);
            // this.dataSource = dataSource
            this.$emit(
              "sortable-change",
              oldindex,
              newindex,
              targetRow,
              this.dataSource
            );
            this.doLayout(true)
          },
        });
        el = null
        })
        
      };
      if (this.isSortable && !this.isTree) {
        this.$nextTick(() => {
          callback();
        });
      }
    },
    getSummaries: function (e) {
      function getDecimalPlaces(num) {
        const str = num.toString();
        if (str.indexOf('.') !== -1) {
          return str.split('.')[1].length;
        }
        return 0;
      }
      var t = this;
      if (this.summaryMethod) return this.summaryMethod(e);
      var n = e.columns,
        r = e.data,
        i = [];
      return (
        n.forEach(function (e, n) {
          if (0 !== n) {
            var o = t.arrayColumns.find(function (t) {
              return t.prop == e.property;
            });
            if (o && o.isSummary) {
              var a = r.map(function (t) {
                return Number(t[e.property]);
              });
              let maxFix = 0
              a.every(function (e) {
                return isNaN(e);
              })
                ? (i[n] = "")
                : (i[n] = ((a.reduce(function (e, t) {
                    var n = Number(t);
                    if (isNaN(n)) return e;
                    let fix = Math.max(getDecimalPlaces(e), getDecimalPlaces(t));
                    if (fix > 0) {
                      if (fix > maxFix) maxFix = fix;
                      e = e*10**fix, t = t*10**fix
                      return (((e + t) / (10**fix)).toFixed(maxFix))*1;
                    }
                    return e + t
                    return isNaN(n) ? e : e + t;
                  }, 0)).toFixed(maxFix))*1);
            } else i[n] = "";
          } else i[n] = t.sumText;
        }),
        [i]
      );
    },
    footerRowspanMethod: function (e) {
      var t = e._rowIndex,
        n = e._columnIndex;
      if (0 === t) {
        if (0 === n)
          return {
            rowspan: 1,
            colspan: this.footerColNum,
          };
        if (n < this.footerColNum)
          return {
            rowspan: 0,
            colspan: 0,
          };
      }
    },
    isRequired: function (e) {
      var t = this.arrayColumns.find(function (t) {
        return t.prop == e;
      });
      return !!t && t.required;
    },
    validate: function () {
      var e = this,
        t = true,
        n = this.getDataSource();
      if (this.required && 0 == n.length)
        return (
          this.$message({
            type: "error",
            message: this.$t("请添加表格数据"),
          }),
          false
        );
      try {
        n.forEach(function (n, r) {
          e.arrayColumns.forEach(function (i) {
            if (!i.isHidden) {
              if (i.required && e.$validatenull(n[i.prop]))
                throw (
                  (e.$message({
                    type: "error",
                    message: e.$t(
                      "请输入第".concat(r + 1, "行-").concat(i.label)
                    ),
                  }),
                  (t = false),
                  new Error())
                );
              i.patterns &&
                i.patterns.length > 0 &&
                i.patterns.forEach(function (o) {
                  if (
                    o.reg &&
                    !e.$validatenull(n[i.prop]) &&
                    !new RegExp(o.reg.substring(1, o.reg.length - 1)).test(
                      n[i.prop]
                    )
                  )
                    throw (
                      (e.$message({
                        type: "error",
                        message: e.$t(
                          ""
                            .concat(o.msg, "第")
                            .concat(r + 1, "行-")
                            .concat(i.label)
                        ),
                      }),
                      (t = false),
                      new Error())
                    );
                });
            }
          });
        });
      } catch (r) {}
      return t;
    },
    handleOk: function (e, t) {
      var n = this;
      e("保存数据...");
      var r =
        window.$getStore({
          name: "table_setting_cols",
        }) || {};
      this.loginInfo
        ? ((r[this.loginInfo.f_UserId] = r[this.loginInfo.f_UserId] || {}),
          (r[this.loginInfo.f_UserId][this.lrTableName] = this.chooseItem
            .filter(function (e) {
              return e._id;
            })
            .map(function (e) {
              return e._id;
            })))
        : (r[this.lrTableName] = this.chooseItem
            .filter(function (e) {
              return e._id;
            })
            .map(function (e) {
              return e._id;
            })),
        window.$setStore({
          name: "table_setting_cols",
          content: r,
        }),
        setTimeout(function () {
          t(), (n.columnsVisible = false);
        }, 1e3);
    },
    openColumnsSetting: function () {
      this.columnsVisible = true;
    },
    columnsSettingOpened: function () {
      var e = this,
        t = this.columnsChecks || this.defaultCheckedKeys;
      (t = t.filter(function (t) {
        return (
          -1 ==
          e.arrayColumns.findIndex(function (e) {
            return e._id == t && e._hasChildren;
          })
        );
      })),
        this.$refs.columnsTree.setCheckedKeys(t);
    },
    handleColumnsCheck: function (e, t) {
      (this.columnsChecks = t.checkedKeys.concat(t.halfCheckedKeys)),
        this.doLayout();
    }
  },
};
</script>
<style lang="less">
@import "./index.less";
</style>
